import React from "react";
 
function DoctorInfoCard() {
  const Doctorinfostyles = `
    .doctor-container {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      padding: 1.5rem;
      background-color: #fff;
      max-width: 480px;
    }
 
    .doctor-container h3 {
      margin-bottom: 0.5rem;
      font-size: 1.25rem;
    }
 
    .doctor-container p {
      color: #6b7280;
      margin-bottom: 1rem;
      font-size: 0.95rem;
    }
 
    .doctor-card {
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      padding: 1rem;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
    }
 
    .doctor-header {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
 
    .doctor-avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      object-fit: cover;
    }
 
    .doctor-name {
      font-weight: bold;
      font-size: 1.05rem;
    }
 
    .specialization {
      color: #6b7280;
      font-size: 0.95rem;
    }
 
    .availability {
      display: flex;
      gap: 0.5rem;
      flex-wrap: wrap;
    }
 
    .pill {
      background-color: #f3f4f6;
      color: #374151;
      padding: 0.25rem 0.75rem;
      font-size: 0.85rem;
      border-radius: 8px;
    }
 
    .schedule-link {
      font-size: 0.9rem;
      color: #2563eb;
      text-decoration: none;
      margin-top: 0.25rem;
    }
 
    .schedule-link:hover {
      text-decoration: underline;
    }
  `;
 
  const selectedDoctor = {
    id: "1",
    DoctorName: "Dr. Kiran",
    specialization: "Neurology",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
  };
 
  return (
    <>
      <style>{Doctorinfostyles}</style>
      <div className="doctor-container mt-3">
        <h4>Tests created by</h4>
        <p></p>
 
        <div className="doctor-card">
          <div className="doctor-header">
            <img
              src={selectedDoctor.image}
              alt={selectedDoctor.DoctorName}
              className="doctor-avatar"
            />
            <div>
              <div className="doctor-name">{selectedDoctor.DoctorName}</div>
              <div className="specialization">
                {selectedDoctor.specialization}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
 
export default DoctorInfoCard;